export default __webpack_public_path__ + "static/media/7ad6a05c5aa3201ab6963fadf9f584c11581601396804.055d80a0.webp";